// 判断是否为开发环境
export const isDevelopment = import.meta.env.DEV || process.env.NODE_ENV === 'development';

// 判断是否启用Mock
export const isMockEnabled = !!import.meta.env.VITE_MOCK;

// 判断是否为生产环境
export const isProduction = import.meta.env.PROD || process.env.NODE_ENV === 'production';


export const G_EmptyStr = '-';

export const PluginIDHashMap: any = {
  // MI - HE 插件 替换
  // 剪映小助手
  '7522412867740565513': '7668633605349834779',


  // SU - TUI 插件 替换
  // 剪映小助手数据生成器
  '7475829177439109155': '7668633605349834779',
  // 视频合成_剪映小助手
  '7457837925833801768': '7668633605349834779',


  // JIAN - CHUANG剪映小助手 替换
  '7576197995168022547': '7668633605349834779',
};
